import { Dialog } from "@headlessui/react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { IKImage } from "imagekitio-react";
import { useDispatch } from "react-redux";
import { editOneDayChallenge } from "../../redux/actions/userActivity";

export function ExtendChallenge() {
  const location = useLocation();
  const user_extended_challenges = useSelector(
    (store) => store?.userActivity?.user_extended_challenges,
  );
  const [extendChallengeModal, setExtendChallengeModal] = useState({
    show: false,
    data: null,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (user_extended_challenges) {
      let sorted_challenges = user_extended_challenges?.sort(
        (a, b) => a?.expires_at - b?.expires_at,
      );
      let today_date = Date.now();

      if (sorted_challenges[0]?.expires_at < today_date) {
        setExtendChallengeModal((prev) => ({
          ...prev,
          show: true,
          data: sorted_challenges[0],
        }));
      }
    }
  }, [location.pathname]);

  function onCloseModal(type) {
    dispatch(editOneDayChallenge(extendChallengeModal.data, type));
    setExtendChallengeModal((prev) => ({ ...prev, show: false, data: null }));
  }

  return (
    <div>
      <Dialog
        open={extendChallengeModal.show}
        onClose={() => onCloseModal(false)}
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex h-[30rem] w-5/6 flex-col items-center justify-between rounded bg-white py-4 px-4 text-center shadow-2xl md:h-4/5 md:w-2/3 md:p-4 lg:w-2/4">
          <div className="flex h-full w-full flex-col items-center justify-between p-2 py-4">
            <h2 className="text-base font-bold md:text-2xl">
              Oh No! Your Challenge Has Expired!
            </h2>
            <img
              urlEndpoint="https://img.learntube.ai/public-assets/"
              src="https://img.learntube.ai/public-assets/Content_player/challengeExpired.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1661768053673"
              className="h-36 w-full md:h-48 md:w-full"
              transformation={[
                {
                  height: "160",
                  width: "160",
                },
              ]}
            />
            <p className="text-sm md:text-lg">
              Your one-day challenge has been expired for{" "}
              <span className="font-semibold text-[#FDBF48]">
                {extendChallengeModal?.data?.["mSkill-name"]}
              </span>{" "}
              in{" "}
              <span className="font-semibold text-[#FDBF48]">
                {extendChallengeModal?.data?.["course-name"]}
              </span>
              . But don't worry, you can request for Extension!
            </p>
            <div className="flex w-2/3 flex-col items-center justify-between md:flex-row">
              <button
                className="mb-3 w-full rounded-lg border-2 border-[#FDBF48] bg-[#FDBF48] px-4 py-2 text-sm font-bold text-white md:mb-0 md:w-auto md:text-base"
                onClick={() => onCloseModal(true)}
              >
                Request Extension
              </button>
              <button
                className=" w-full rounded-lg border-2 border-[#FDBF48] px-4 py-2 text-sm font-bold text-[#FDBF48] md:w-auto md:text-base"
                onClick={() => onCloseModal(false)}
              >
                Mark as Failed
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
